export default "__VITE_ASSET__d51c0953__"